var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fading-container fade",attrs:{"id":"docTemplateBlock"}},[_c('input',{attrs:{"type":"hidden","name":"oneDocLoaded","id":"oneDocLoaded","value":"false"}}),_c('input',{attrs:{"type":"hidden","name":"oneDocCompleted","id":"oneDocCompleted","value":"false"}}),_c('iframe',{staticClass:"spaIframe",attrs:{"id":"oneDoCSpa","allowfullscreen":""}})])
}]

export { render, staticRenderFns }